module.exports = __webpack_public_path__ + "static/img/Zach-Merrett.8db892c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Zach-Merrett.jpg
// module id = Dc3N
// module chunks = 0